export const DEFAULT_THEME = 'slate';

export const THEME_STORAGE_KEY = 'crmTheme';

export const ADMIN_THEMES = [
  {
    id: 'slate',
    label: 'Slate',
    description: 'Default blue accent on light gray workspace.',
    preview: ['#121820', '#1d4ed8', '#f1f5f9'],
  },
  {
    id: 'ocean',
    label: 'Ocean',
    description: 'Deep navy sidebar with sky-blue accents.',
    preview: ['#0c4a6e', '#0284c7', '#ecfeff'],
  },
  {
    id: 'forest',
    label: 'Forest',
    description: 'Dark green sidebar with emerald highlights.',
    preview: ['#14532d', '#059669', '#ecfdf5'],
  },
  {
    id: 'midnight',
    label: 'Midnight',
    description: 'True black dark mode with orange accents.',
    preview: ['#000000', '#ea580c', '#141414'],
  },
  {
    id: 'rose',
    label: 'Rose',
    description: 'Warm charcoal sidebar with rose accents.',
    preview: ['#292524', '#e11d48', '#fff1f2'],
  },
];

export function normalizeTheme(theme) {
  const match = ADMIN_THEMES.find((entry) => entry.id === theme);
  return match ? match.id : DEFAULT_THEME;
}

export function applyTheme(theme) {
  const normalized = normalizeTheme(theme);
  document.documentElement.setAttribute('data-theme', normalized);
  localStorage.setItem(THEME_STORAGE_KEY, normalized);
  return normalized;
}

export function readStoredTheme() {
  return normalizeTheme(localStorage.getItem(THEME_STORAGE_KEY));
}
